import { render, staticRenderFns } from "./NibPerStatusPenanamanModal.vue?vue&type=template&id=6a357d24&scoped=true&"
import script from "./NibPerStatusPenanamanModal.vue?vue&type=script&lang=js&"
export * from "./NibPerStatusPenanamanModal.vue?vue&type=script&lang=js&"
import style0 from "./NibPerStatusPenanamanModal.vue?vue&type=style&index=0&id=6a357d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a357d24",
  null
  
)

export default component.exports